/** InsCoder WANG.J 2025-08-30 B + Sticky navigation bar functionality **/

class CustStickyBar extends HTMLElement {
  constructor() {
    super();
    this.isInitialized = false;
    this.sections = [];
    this.navLinks = [];
    this.activeSection = null;
    this.scrollThrottle = null;
    this.observer = null;
    /** InsCoder WANG.J 2025-09-05 B + Hide effect scroll detection **/
    this.lastScrollY = window.scrollY;
    this.scrollDirection = null;
    this.isHidden = false;
    /** InsCoder WANG.J 2025-09-05 E + Hide effect scroll detection **/
  }

  connectedCallback() {
    if (!this.isInitialized) {
      this.init();
      this.isInitialized = true;
    }
  }

  disconnectedCallback() {
    this.cleanup();
  }

  init() {
    this.setupElements();
    this.setupEventListeners();
    this.setupIntersectionObserver();
    this.updateActiveSection();
  }

  setupElements() {
    this.navLinks = Array.from(this.querySelectorAll('.cust-sticky-bar__nav-link'));
    this.sections = this.navLinks.map(link => {
      const anchorId = link.getAttribute('data-anchor');
      const section = document.getElementById(anchorId);
      return {
        link: link,
        section: section,
        id: anchorId
      };
    }).filter(item => item.section);
  }

  setupEventListeners() {
    // Smooth scroll for navigation links
    this.navLinks.forEach(link => {
      link.addEventListener('click', this.handleNavClick.bind(this));
    });

    // Scroll tracking for sticky behavior
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // Handle resize for responsive behavior
    window.addEventListener('resize', this.handleResize.bind(this));


    const buy_buttons = this.querySelectorAll(".cust-sticky-bar__cta a");

    buy_buttons.forEach(button => {
      button.addEventListener("click", (event)=> {
        const variantId = button.dataset.variantId;
        if(!variantId){
          return;
        }
        event.preventDefault();
        event.stopPropagation();

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        
        const config = theme.utils.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('sections', sectionsToBundle);
        formData.append('sections_url', window.location.pathname);
        formData.append("id", variantId);
        formData.append("quantity", 1)
        config.body = formData;

        this.activeElement = event.submitter || event.currentTarget;
        
        fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (parsedState) => {
          if (parsedState.status) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: parsedState.errors || parsedState.description,
              message: parsedState.message
            });
            // this.handleErrorMessage(parsedState.description);
            document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
              detail: {
                errorMessage: parsedState.description
              }
            }));
            return;
          }

          const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET')})).json();
          cartJson['sections'] = parsedState['sections'];

          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cart: cartJson });
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: parsedState
            }
          }));

          document.querySelector('cart-drawer')?.show(this.activeElement);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
        });
      })
    })
    
  }

  handleNavClick(event) {
    event.preventDefault();
    
    const link = event.currentTarget;
    const anchorId = link.getAttribute('data-anchor');
    const targetSection = document.getElementById(anchorId);
    
    if (targetSection) {
      // Calculate offset to account for sticky bar height
      const stickyBarHeight = this.offsetHeight;
      const targetPosition = targetSection.offsetTop - stickyBarHeight - 20; // 20px extra padding
      
      // Smooth scroll to target
      window.scrollTo({
        top: Math.max(0, targetPosition),
        behavior: 'smooth'
      });
      
      // Update active state immediately for better UX
      this.setActiveLink(link);
    }
  }

  handleScroll() {
    if (this.scrollThrottle) return;
    
    this.scrollThrottle = requestAnimationFrame(() => {
      this.updateStickyState();
      /** InsCoder WANG.J 2025-09-05 B + Hide effect scroll handling **/
      this.updateHideEffect();
      /** InsCoder WANG.J 2025-09-05 E + Hide effect scroll handling **/
      this.updateActiveSection();
      this.scrollThrottle = null;
    });
  }

  handleResize() {
    // Recalculate sections on resize
    setTimeout(() => {
      this.setupElements();
    }, 100);
  }

  updateStickyState() {

    const stickyBar = document.querySelector('.cust-sticky-bar-section');

    const rect = stickyBar.getBoundingClientRect();

    if (rect.bottom < 0) {
      this.classList.remove('hidden');
    }

    if (window.scrollY === 0) {
      this.classList.add('hidden');
    }


    const scrolled = window.scrollY > 50;
    this.classList.toggle('is-scrolled', scrolled);
  }

  /** InsCoder WANG.J 2025-09-05 B + Hide effect update method **/
  updateHideEffect() {
    // Only apply hide effect if the element has hide-effect class
    if (!this.classList.contains('hide-effect')) {
      return;
    }

    const currentScrollY = window.scrollY;
    const scrollThreshold = 100; // Minimum scroll distance to trigger hide/show

    // Determine scroll direction
    if (currentScrollY > this.lastScrollY) {
      this.scrollDirection = 'up';
    } else if (currentScrollY < this.lastScrollY) {
      this.scrollDirection = 'down';
    }

    // Only apply effect if we've scrolled past the threshold
    if (currentScrollY > scrollThreshold) {
      if (this.scrollDirection === 'up' && !this.isHidden) {
        // Scrolling up - hide the bar
        this.classList.add('sticky-bar-hidden');
        this.isHidden = true;
      } else if (this.scrollDirection === 'down' && this.isHidden) {
        // Scrolling down - show the bar
        this.classList.remove('sticky-bar-hidden');
        this.isHidden = false;
      }
    } else {
      // Always show when near top of page
      if (this.isHidden) {
        this.classList.remove('sticky-bar-hidden');
        this.isHidden = false;
      }
    }

    this.lastScrollY = currentScrollY;
  }
  /** InsCoder WANG.J 2025-09-05 E + Hide effect update method **/

  setupIntersectionObserver() {
    if (!window.IntersectionObserver) {
      return; // Fallback for older browsers
    }

    const options = {
      root: null,
      rootMargin: `-${this.offsetHeight + 50}px 0px -50% 0px`,
      threshold: [0, 0.1, 0.5, 1]
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
          const sectionData = this.sections.find(s => s.section === entry.target);
          if (sectionData) {
            this.setActiveLink(sectionData.link);
          }
        }
      });
    }, options);

    // Observe all sections
    this.sections.forEach(sectionData => {
      if (sectionData.section) {
        this.observer.observe(sectionData.section);
      }
    });
  }

  updateActiveSection() {
    if (this.observer || this.sections.length === 0) return;
    
    // Fallback method for browsers without IntersectionObserver
    const scrollPosition = window.scrollY + this.offsetHeight + 100;
    let activeSection = null;
    
    this.sections.forEach(sectionData => {
      if (sectionData.section) {
        const sectionTop = sectionData.section.offsetTop;
        const sectionBottom = sectionTop + sectionData.section.offsetHeight;
        
        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          activeSection = sectionData;
        }
      }
    });
    
    if (activeSection && activeSection !== this.activeSection) {
      this.setActiveLink(activeSection.link);
    }
  }

  setActiveLink(activeLink) {
    // Remove active class from all links
    this.navLinks.forEach(link => {
      link.classList.remove('active');
    });
    
    // Add active class to current link
    if (activeLink) {
      activeLink.classList.add('active');
      this.activeSection = this.sections.find(s => s.link === activeLink);
      
      // Ensure active link is visible on mobile
      this.ensureLinkVisible(activeLink);
    }
  }

  ensureLinkVisible(link) {
    const nav = this.querySelector('.cust-sticky-bar__nav');
    if (!nav || window.innerWidth > 767) return;
    
    const navRect = nav.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();
    
    if (linkRect.left < navRect.left || linkRect.right > navRect.right) {
      nav.scrollTo({
        left: link.offsetLeft - nav.offsetWidth / 2 + link.offsetWidth / 2,
        behavior: 'smooth'
      });
    }
  }

  cleanup() {
    if (this.observer) {
      this.observer.disconnect();
    }
    
    if (this.scrollThrottle) {
      cancelAnimationFrame(this.scrollThrottle);
    }
    
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  // Public method to programmatically navigate to a section
  navigateToSection(sectionId) {
    const targetSection = document.getElementById(sectionId);
    const targetLink = this.navLinks.find(link => 
      link.getAttribute('data-anchor') === sectionId
    );
    
    if (targetSection && targetLink) {
      targetLink.click();
    }
  }

  // Public method to update navigation items dynamically
  updateNavigation(navItems) {
    const navList = this.querySelector('.cust-sticky-bar__nav-list');
    if (!navList) return;
    
    // Clear existing items
    navList.innerHTML = '';
    
    // Add new items
    navItems.forEach(item => {
      const li = document.createElement('li');
      li.className = 'cust-sticky-bar__nav-item';
      
      const a = document.createElement('a');
      a.href = `#${item.id}`;
      a.className = 'cust-sticky-bar__nav-link';
      a.setAttribute('data-anchor', item.id);
      a.textContent = item.title;
      
      li.appendChild(a);
      navList.appendChild(li);
    });
    
    // Reinitialize
    this.setupElements();
    this.setupIntersectionObserver();
  }
}

// Register the custom element
customElements.define('cust-sticky-bar', CustStickyBar);

// Initialize for sections that might be loaded dynamically
document.addEventListener('DOMContentLoaded', () => {
  const stickyBars = document.querySelectorAll('.cust-sticky-bar');
  stickyBars.forEach(bar => {
    if (!customElements.get('cust-sticky-bar')) {
      // Fallback initialization if custom elements aren't supported
      const instance = new CustStickyBar();
      instance.init.call(bar);
    }
  });
});

// Global utility function for external use
window.StickyBarUtils = {
  navigateToSection: (sectionId) => {
    const stickyBar = document.querySelector('cust-sticky-bar');
    if (stickyBar && stickyBar.navigateToSection) {
      stickyBar.navigateToSection(sectionId);
    }
  },
  
  updateNavigation: (navItems) => {
    const stickyBar = document.querySelector('cust-sticky-bar');
    if (stickyBar && stickyBar.updateNavigation) {
      stickyBar.updateNavigation(navItems);
    }
  }
};

/** InsCoder WANG.J 2025-08-30 E + Sticky navigation bar functionality **/